<template functional>
    <div>
        Guess the payment card expiration by attempting up to 3 guesses at a new expiration date (based on an analysis of likely variations).
    </div>
</template>

<script>
    export default {
        name: 'guess-payment-card-expiration-summary',
    };
</script>
